module.exports = __webpack_public_path__ + "c90fe2109678e38f6bcc2b39c7ef49d6.svg";